<script lang="ts">
    import { onMount } from 'svelte';
    import { storePages, emptyPage, Page } from '../scripts/classes/page';
    import BallsDecouvrir from '../components/BallsDecouvrir.svelte';
    import NewsletterRegistration from '../components/NewsletterRegistration.svelte';

    let page: Page = emptyPage;
    const idPage = 5;

    onMount(async () => {
        window.scrollTo(0,0);
        page = $storePages.filter(item => {
            return (item.id == idPage);
        })[0];
	});

</script>
    
<style lang="scss">

    .charte {
        margin-bottom: 90px;
        &__intro {
            width: 100%;
            height: 100%;
            margin-bottom: 50px;
        }
    }

    @include large {
        .charte {
            &__intro {
                width: 90%;
            }
        }
    }

</style>

<div class="page">
    <div class="page__contener charte">
        <div class="page__title">Budget 2025</div>
        <div class="page__intro charte__intro">
            <iframe id="idbudget2025" title="Budget 2025" width="100%" height="100%" src="../assets/budget2025.html"></iframe>
        </div>
    </div>
    <NewsletterRegistration />
    <BallsDecouvrir />
</div>
